import { Button, Paper, Stack, Typography } from '@mui/material';

interface SalaryFormSectionProps {
    title: React.ReactNode;
    onAdd: () => void;
    addLabel: string;
    children: React.ReactNode;
}

/**
 * Shared layout component for salary tab form sections.
 * Wraps form fields in a Paper with a title and an "Add" button.
 */
const SalaryFormSection = ({ title, onAdd, addLabel, children }: SalaryFormSectionProps) => (
    <Paper sx={{ p: 2 }}>
        <Typography variant="h6" gutterBottom>
            {title}
        </Typography>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} alignItems="center">
            {children}
            <Button variant="contained" onClick={onAdd}>
                {addLabel}
            </Button>
        </Stack>
    </Paper>
);

export default SalaryFormSection;
